import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined';
import CustomIconButton from 'common/components/CustomIconButton';
import CustomTooltip from 'common/components/CustomTooltip';
import useFlexBoxStyles from 'common/flexBox';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    brokenIcon: {
        '& svg': {
            fill: theme.palette.error.main,
        },
    },
}));
const ProductBroken = (props) => {
    const { product, size = 'inherit', className } = props;
    const { t } = useTranslation();
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const { classes } = useStyles();

    const isBrokenUrl = () => {
        return product.broken || product?.variants?.some((variant) => variant.broken);
    };

    return (
        <>
            {isBrokenUrl() ? (
                <div className={cx(flexBox.absolute, flexBox.left1, flexBox.top1, flexBox.zIndex1, className)}>
                    <CustomTooltip arrow title={t('product.productItem.brokenUrl')} placement="bottom">
                        <CustomIconButton hideBorder={true} className={classes.brokenIcon} size={size}>
                            <LinkOffOutlinedIcon />
                        </CustomIconButton>
                    </CustomTooltip>
                </div>
            ) : null}
        </>
    );
};

export default ProductBroken;
